import React from 'react';
import { useSelector } from 'react-redux';
import { getShowLocalizationSettings } from '@app/redux/localization/selectors';

import loadable from '@app/ui/components/LazyLoad';

//
// Component to load
const LocalizationMenu = loadable(
  () =>
    import(
      /* webpackChunkName: "lazy.localizationMenu" */ './LocalizationMenu'
    ),
);

//
// Check to load
const useShouldShow = (): boolean => useSelector(getShowLocalizationSettings);

const LocalizationMenuLazy = () => {
  const shouldShow = useShouldShow();

  if (!shouldShow) {
    return null;
  }

  return <LocalizationMenu />;
};

export default LocalizationMenuLazy;
